document.addEventListener("DOMContentLoaded", () => {
  const cursor = document.querySelector(".custom-cursor");
  const cursorInner = cursor?.querySelector(".custom-cursor__inner");

  if (!cursor || !cursorInner) return;

  const supportsCustomCursor = window.matchMedia(
    "(hover: hover) and (pointer: fine)",
  ).matches;

  if (!supportsCustomCursor) {
    cursor.hidden = true;
    return;
  }

  const COLORS = {
    default: "#392422",
    media: "#A69167",
    brown: "#f9f6ed",
  };

  const INTERACTIVE_SELECTOR = [
    "a",
    "button",
    "input",
    "select",
    "textarea",
    "label",
    "summary",
    '[role="button"]',
    '[tabindex]:not([tabindex="-1"])',
    ".header__menu-control",
    ".visionaries-ticker__control",
    ".privacy-modal--header--close",
    ".visionaries-ticker__carousel",
    ".floor-selector__floor",
    '.floor-plan-interactive-experience__floor-plan [id^="room-"]',
    ".swiper",
    ".pswp__zoom-wrap",
    ".section-item--title",
    ".video__overlay",
  ].join(", ");

  const MEDIA_SELECTOR = "img, video, .video-embed";
  const BROWN_SELECTOR = ".bg-brown, .inquiry-form";
  const IFRAME_SELECTOR = "iframe";

  let mouseX = window.innerWidth / 2;
  let mouseY = window.innerHeight / 2;
  let currentColor = COLORS.default;
  let isInteractive = false;
  let needsHitTest = true;

  cursorInner.style.backgroundColor = currentColor;

  function setCursorColor(color) {
    if (color === currentColor) return;

    currentColor = color;
    cursorInner.style.backgroundColor = color;
  }

  function updateCursorState() {
    const el = document.elementFromPoint(mouseX, mouseY);
    const isIframe = Boolean(el?.closest(IFRAME_SELECTOR));

    const nextIsInteractive = Boolean(el?.closest(INTERACTIVE_SELECTOR));

    cursor.classList.toggle("custom-cursor--hidden", isIframe);

    if (nextIsInteractive !== isInteractive) {
      isInteractive = nextIsInteractive;
      cursor.classList.toggle("custom-cursor--interactive", isInteractive);
    }

    if (el?.closest(BROWN_SELECTOR)) {
      setCursorColor(COLORS.brown);
    } else if (el?.closest(MEDIA_SELECTOR)) {
      setCursorColor(COLORS.media);
    } else {
      setCursorColor(COLORS.default);
    }
  }

  function animate() {
    cursor.style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0) translate(-50%, -50%)`;

    if (needsHitTest) {
      updateCursorState();
      needsHitTest = false;
    }

    requestAnimationFrame(animate);
  }

  window.addEventListener(
    "pointermove",
    (event) => {
      mouseX = event.clientX;
      mouseY = event.clientY;
      needsHitTest = true;
    },
    { passive: true },
  );

  animate();
});
